import { render, staticRenderFns } from "./OthersModule.vue?vue&type=template&id=59f57722&"
import script from "./OthersModule.vue?vue&type=script&lang=js&"
export * from "./OthersModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports